/**
 * DW-e (besluit Frank 24 oktober 2026): de bronnen en het tijdstip van een worker bewerken bij
 * Agenten. PUUR. De backend controleert hetzelfde (`workerzin.bewerkte_bronnen` en
 * `bewerkt_tijdstip`); dit is alleen wat het formulier ermee doet.
 */

/** De dagbronnen in de volgorde van de kaart; dezelfde namen als `workerzin.BRONNAMEN`. */
export const BRONNEN = ["tasq", "fathom", "agenda", "mail", "drive"];

export const DAGEN_KORT = {
  nl: ["ma", "di", "wo", "do", "vr", "za", "zo"],
  en: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
};

/** Zonder eigen keuze: maandag om 08:00, zoals een worker die zonder uur wordt gemaakt. */
export const STANDAARD = { dagen: [0], uur: 8, minuut: 0 };

/** Een dag aan of uit; de laatste dag blijft staan, want een tijdstip zonder dag draait nooit. */
export function zetDag(tijdstip, dag) {
  const dagen = new Set(tijdstip?.dagen || []);
  if (dagen.has(dag)) {
    if (dagen.size === 1) return { ...tijdstip, dagen: [...dagen] };
    dagen.delete(dag);
  } else {
    dagen.add(dag);
  }
  return { ...tijdstip, dagen: [...dagen].sort((a, b) => a - b) };
}

/** "07:45" voor een tijdveld. */
export function naarInvoer(tijdstip) {
  if (!tijdstip) return "";
  return `${String(tijdstip.uur).padStart(2, "0")}:${String(tijdstip.minuut || 0).padStart(2, "0")}`;
}

/** Een tijdveld terug naar uur en minuut; een onleesbare waarde verandert niets. */
export function vanInvoer(tijdstip, tekst) {
  const m = /^(\d{1,2}):(\d{2})$/.exec(tekst || "");
  if (!m) return tijdstip;
  const uur = Number(m[1]);
  const minuut = Number(m[2]);
  if (uur > 23 || minuut > 59) return tijdstip;
  return { ...tijdstip, uur, minuut };
}

/** Wat er naar PUT /api/agents/{id} gaat: zonder zone, want die blijft die van de worker. */
export function voorOpslaan(tijdstip) {
  if (!tijdstip) return null;
  return { dagen: [...tijdstip.dagen], uur: tijdstip.uur, minuut: tijdstip.minuut || 0 };
}
